import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium';
import { TABLE_MIN_COLUMN_WIDTH } from '../../constants';
import { TType } from '../../hooks/useTranslation';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { getDifferentFY, getFY, getFyNumber } from '../../utils/calculation';
import { returnNumberColumn } from '../../utils/tableUtils';

const returnProjectForecastingColumns = (fy = getFY(-2)) => {
  const fiscalYears = getDifferentFY(fy);
  return fiscalYears.reduce(
    (fiscalYears, currentYear) => [
      ...fiscalYears,
      returnReusedForecastColumns(currentYear),
    ],

    [],
  );
};

export const returnReusedForecastColumns = (currentYear) => [
  returnNumberColumn(
    `BU${getFyNumber(currentYear)}`,
    `investment${currentYear}`,
  ),
  returnNumberColumn(
    `Land Cost ${getFyNumber(currentYear)}`,
    `landCost${currentYear}`,
  ),
  returnNumberColumn(
    `Property Investment ${getFyNumber(currentYear)}`,
    `propertyInvestment${currentYear}`,
  ),
  returnNumberColumn(
    `Retail Investment ${getFyNumber(currentYear)}`,
    `retailInvestment${currentYear}`,
  ),
  returnNumberColumn(
    `Retail Cost ${getFyNumber(currentYear)}`,
    `retailCost${currentYear}`,
  ),
];

export const getCurrencyTableColumns = (
  editable: boolean,
  t: TType,
): GridColDef[] => [
  {
    field: 'countryName',
    headerName: t('common.country'),
    width: 300,
    minWidth: TABLE_MIN_COLUMN_WIDTH,
    renderCell: (params: GridRenderCellParams) => (
      <Tooltip title={params?.row?.countryName}>
        <Typography noWrap>{params?.row?.countryName}</Typography>
      </Tooltip>
    ),
  },
  {
    field: 'countryId',
    headerName: t('common.countryCode'),
    width: 200,
    minWidth: TABLE_MIN_COLUMN_WIDTH,
    renderCell: (params: GridRenderCellParams) => (
      <Tooltip title={params?.row?.countryId}>
        <Typography noWrap>{params?.row?.countryId}</Typography>
      </Tooltip>
    ),
  },
  {
    field: 'currencyCode',
    headerName: t('currency.currencyTable.currencyCode'),
    width: 200,
    minWidth: TABLE_MIN_COLUMN_WIDTH,
    renderCell: (params: GridRenderCellParams) => (
      <Tooltip title={params?.row?.currencyCode}>
        <Typography noWrap>{params?.row?.currencyCode}</Typography>
      </Tooltip>
    ),
  },
  {
    field: 'currencyRate',
    headerName: t('currency.currencyTable.currencyRate'),
    width: 200,
    minWidth: TABLE_MIN_COLUMN_WIDTH,
    editable: editable,
    type: 'number',
    renderCell: (params: GridRenderCellParams) => (
      <Tooltip title={params?.row?.currencyRate}>
        <Typography noWrap>{params?.row?.currencyRate}</Typography>
      </Tooltip>
    ),
  },
  ...returnProjectForecastingColumns().flat(1),
];
